var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.isMobile && _vm.showCourseList.length >= _vm.DISPLAYING_LIMIT
        ? _c(
            "VueSlickCarousel",
            _vm._b(
              {
                staticClass: "vue-slick-carousel",
                on: { beforeChange: _vm.carouselBeforeChange },
                scopedSlots: _vm._u(
                  [
                    !_vm.isMobile
                      ? {
                          key: "prevArrow",
                          fn: function() {
                            return [
                              _c(
                                "div",
                                { staticClass: "arrow-icon arrow-icon__left" },
                                [
                                  _c("PrevArrowIcon", {
                                    style: _vm.getArrowIconStyle(
                                      _vm.currentCourseNumber <= 0
                                    )
                                  })
                                ],
                                1
                              )
                            ]
                          },
                          proxy: true
                        }
                      : null,
                    !_vm.isMobile
                      ? {
                          key: "nextArrow",
                          fn: function() {
                            return [
                              _c(
                                "div",
                                { staticClass: "arrow-icon arrow-icon__right" },
                                [
                                  _c("NextArrowIcon", {
                                    style: _vm.getArrowIconStyle(
                                      _vm.currentCourseNumber >=
                                        _vm.courseListLength -
                                          _vm.DISPLAYING_LIMIT
                                    )
                                  })
                                ],
                                1
                              )
                            ]
                          },
                          proxy: true
                        }
                      : null
                  ],
                  null,
                  true
                )
              },
              "VueSlickCarousel",
              _vm.carouselSettings,
              false
            ),
            _vm._l(_vm.showCourseList, function(item) {
              return _c("course-card", {
                key: item.id,
                attrs: { info: item, "load-image-lazily": "" }
              })
            }),
            1
          )
        : _c(
            "div",
            { staticClass: "slide-carousel" },
            _vm._l(_vm.showCourseList, function(item) {
              return _c("course-card", {
                key: item.id,
                class: {
                  "card--fixed-width": !_vm.isMobile
                },
                attrs: { info: item, "load-image-lazily": "" }
              })
            }),
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }